/**
 * Auth
 */
// @ts-ignore
import Auth0 from 'auth0-js';

import {
    Auth0Credentials,
    Auth0Error,
    Auth0LoginResponse,
    Auth0DelegationResponse,
    Auth0DecodedHash
} from './types';

// Environment
const {
    REACT_APP_AUTH0_CLIENT,
    REACT_APP_AUTH0_DOMAIN,
    REACT_APP_CONNECTION_ID
} = process.env;

class Auth {
    auth0 = new Auth0.WebAuth({
        domain: REACT_APP_AUTH0_DOMAIN,
        clientID: REACT_APP_AUTH0_CLIENT,
        callbackURL: window.location.href,
        responseType: 'token'
    });

    constructor() {
        this.login = this.login.bind(this);
        this.getDelegationToken = this.getDelegationToken.bind(this);
        this.signInAsUser = this.signInAsUser.bind(this);
    }

    /**
     * Login user
     * @param  {Object} credentials User's login credentails
     * @return {Promise}            Promise object represents the users idToken
     */
    login(credentials: Auth0Credentials): Promise<any> {
        return new Promise((resolve, reject) => {
            const callback = (
                err: Auth0Error,
                res: Auth0LoginResponse
            ): void => {
                if (err) {
                    reject(err);
                    return undefined;
                }
                resolve(res.accessToken);
                return undefined;
            };

            const options = {
                realm: REACT_APP_CONNECTION_ID,
                scope: 'read:current_user openid offline_access',
                audience: `https://${REACT_APP_AUTH0_DOMAIN}/api/v2/`,
                grant_type: 'password',
                ...credentials
            };

            return this.auth0.client.login(options, callback);
        });
    }

    /**
     * Get Delegation Token
     * @param  {string} idToken JSON Web Token (JWT) that contains user profile information
     * @return {Promise}        Promise object represents the users new idToken
     */
    getDelegationToken(idToken: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const callback = (
                err: Auth0Error,
                res: Auth0DelegationResponse
            ): void => {
                if (err) {
                    reject(err);
                    return undefined;
                }
                resolve(res.id_token);
                return undefined;
            };

            const options = {
                id_token: idToken,
                api: 'app',
                scope: 'openid settings name email'
            };

            return this.auth0.getDelegationToken(options, callback);
        });
    }

    /**
     * Sign In As User
     * @param  {string} hash Auth0 URL hash fragment
     * @return {string}      Impersinated User's idToken
     */
    signInAsUser(hash: string): Auth0DecodedHash {
        const { idToken } = this.auth0.parseHash(hash);
        return idToken;
    }
}

export default new Auth();
